import { formatNumber, FormatNumberOptions } from './formatNumber';

/**
 * Formats a given value as a USD currency string.
 *
 * @param value - The numeric value to format. Can be a number or a string that will be parsed into a number.
 * @param options - Optional. Additional options to customize the number formatting.
 * @returns A string representing the formatted USD currency, or `undefined` if the value cannot be parsed into a number.
 */
export function formatUsd(
  value: number | string | undefined,
  options: FormatNumberOptions & { fallback: string },
): string;
export function formatUsd(
  value?: number | string,
  options?: FormatNumberOptions,
): string | undefined;
export function formatUsd(
  value: number | string = '',
  options?: FormatNumberOptions,
) {
  return formatNumber(value, {
    style: 'currency',
    currency: 'USD',
    notation: 'standard',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    ...options,
  });
}
